<div *ngIf="activado===true">
  <div class="d-flex justify-content-center">
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
    <path d="M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.82-8.69a.486.486 0 0 1 .04-.045z"/>
  </svg> </div>
  <div class="d-flex justify-content-center"> <p class="h1">Tu usuario fue activado</p></div>
  <div class="d-flex justify-content-center"><button class="btn btn-primary" type="button" (click)="redir()">Ingresar</button></div>
</div>
